import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=270c0a35&"
import script from "./Banner.vue?vue&type=script&lang=js&"
export * from "./Banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('270c0a35')) {
      api.createRecord('270c0a35', component.options)
    } else {
      api.reload('270c0a35', component.options)
    }
    module.hot.accept("./Banner.vue?vue&type=template&id=270c0a35&", function () {
      api.rerender('270c0a35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Affiliates/Banner.vue"
export default component.exports